import { useState } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';

//lib
import { deleteApi } from '@/utils/client';

import PropTypes from 'prop-types';

import { DELETE_REPORT } from '@/lib/routes/apiEndpoints';

import Button from '@/components/base/Button';
import InfoBanner from '@/components/base/InfoBanner';
// Components
import Modal from '@/components/base/Modal';

const ReportDeleteContent = ({ toggle, params, mutateReports }) => {
    const { t } = useTranslation();
    const [requestState, setRequestState] = useState({ isSubmitting: false, error: null });

    const onConfirm = async () => {
        setRequestState({ isSubmitting: true, error: null });
        try {
            await deleteApi(DELETE_REPORT, {
                data: { scheduler_ids: [params.id] }
            });
            await mutateReports(null);
            toggle();
        } catch (e) {
            setRequestState({ isSubmitting: false, error: t('errors:error_occurred_delete_data') });
        }
    };

    return (
        <>
            <Modal.Body>
                {requestState?.error ? (
                    <InfoBanner
                        className="mb-8"
                        onClose={() =>
                            setRequestState((prevState) => ({ ...prevState, error: null }))
                        }>
                        <span>{requestState?.error}</span>
                    </InfoBanner>
                ) : null}
                <Modal.Title>{t('reports:general.delete_modal_title')}</Modal.Title>
                <Modal.Content className="pt-8 text-center text-sm text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {t('reports:general.delete_scheduled_report')}
                </Modal.Content>
            </Modal.Body>
            <Modal.Footer className="flex flex-col items-center justify-between space-y-3 px-12 pb-12 pt-8 xs:flex-row xs:space-x-3 xs:space-y-0">
                <Button className="w-full" variant="secondary" onClick={toggle}>
                    {t('commons:no')}
                </Button>
                <Button
                    className="w-full"
                    isLoading={requestState?.isSubmitting}
                    onClick={onConfirm}>
                    {t('commons:yes')}
                </Button>
            </Modal.Footer>
        </>
    );
};

ReportDeleteContent.propTypes = {
    toggle: PropTypes.func.isRequired,
    params: PropTypes.object,
    mutateReports: PropTypes.func.isRequired
};

const DeleteReportModal = ({ isOpen, toggle, params, mutateReports }) => {
    return (
        <Modal open={isOpen} onDismiss={toggle}>
            <ReportDeleteContent toggle={toggle} params={params} mutateReports={mutateReports} />
        </Modal>
    );
};

DeleteReportModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    params: PropTypes.object,
    mutateReports: PropTypes.func.isRequired
};

export default DeleteReportModal;
